import React from "react";
import { Navigate, RouteObject } from "react-router-dom";

import { EXPERIENCE_ROUTES, GENERAL_ROUTES } from "../../routes";

export const ExperienceRoutes: RouteObject[] = [
  // The all-experiences table lives on the home page
  {
    path: EXPERIENCE_ROUTES.Experiences,
    element: <Navigate to={GENERAL_ROUTES.Index} replace />,
  },
  {
    path: EXPERIENCE_ROUTES.Experiences_Content,
    lazy: async () => {
      const { ContentExperiencesRoute } =
        await import("@src/domains/experienceTablePages/routes/ContentExperiences.route");
      const { ScopedRoute } =
        await import("@src/components/LimitAccess/ScopedRoute");

      return {
        element: (
          <ScopedRoute
            isEnabled={() => true}
            debugId={EXPERIENCE_ROUTES.Experiences_Content}
            children={ContentExperiencesRoute}
          />
        ),
      };
    },
  },
  {
    path: EXPERIENCE_ROUTES.Experiences_Merchandising,
    lazy: async () => {
      const { MerchandisingExperiencesRoute } =
        await import("@src/domains/experienceTablePages/routes/MerchandisingExperiences.route");
      const { ScopedRoute } =
        await import("@src/components/LimitAccess/ScopedRoute");

      return {
        element: (
          <ScopedRoute
            isEnabled={() => true}
            debugId={EXPERIENCE_ROUTES.Experiences_Merchandising}
            children={MerchandisingExperiencesRoute}
          />
        ),
      };
    },
  },
  {
    path: EXPERIENCE_ROUTES.Experiences_Pricing,
    lazy: async () => {
      const { PricingExperiencesRoute } =
        await import("@src/domains/experienceTablePages/routes/PricingExperiences.route");
      const { ScopedRoute } =
        await import("@src/components/LimitAccess/ScopedRoute");

      return {
        element: (
          <ScopedRoute
            isEnabled={() => true}
            debugId={EXPERIENCE_ROUTES.Experiences_Pricing}
            children={PricingExperiencesRoute}
          />
        ),
      };
    },
  },
  {
    path: EXPERIENCE_ROUTES.Experiences_Shipping,
    lazy: async () => {
      const { ShippingExperiencesRoute } =
        await import("@src/domains/experienceTablePages/routes/ShippingExperiences.route");
      const { ScopedRoute } =
        await import("@src/components/LimitAccess/ScopedRoute");

      return {
        element: (
          <ScopedRoute
            isEnabled={() => true}
            debugId={EXPERIENCE_ROUTES.Experiences_Shipping}
            children={ShippingExperiencesRoute}
          />
        ),
      };
    },
  },
  {
    path: EXPERIENCE_ROUTES.Experiences_Checkout,
    lazy: async () => {
      const { CheckoutExperiencesRoute } =
        await import("@src/domains/experienceTablePages/routes/CheckoutExperiences.route");
      const { ScopedRoute } =
        await import("@src/components/LimitAccess/ScopedRoute");

      return {
        element: (
          <ScopedRoute
            isEnabled={() => true}
            debugId={EXPERIENCE_ROUTES.Experiences_Checkout}
            children={CheckoutExperiencesRoute}
          />
        ),
      };
    },
  },
  {
    path: EXPERIENCE_ROUTES.Experiences_PostPurchaseModule,
    lazy: async () => {
      const { PostPurchaseExperiencesRoute } =
        await import("@src/domains/experienceTablePages/routes/PostPurchaseExperiences.route");
      const { ScopedRoute } =
        await import("@src/components/LimitAccess/ScopedRoute");

      return {
        element: (
          <ScopedRoute
            isEnabled={() => true}
            debugId={EXPERIENCE_ROUTES.Experiences_PostPurchaseModule}
            children={PostPurchaseExperiencesRoute}
          />
        ),
      };
    },
  },
  // Legacy pre-module-nav paths → closest new module table
  {
    path: EXPERIENCE_ROUTES.Experiences_Offers,
    element: (
      <Navigate to={EXPERIENCE_ROUTES.Experiences_Merchandising} replace />
    ),
  },
  {
    path: EXPERIENCE_ROUTES.Experiences_SiteContent,
    element: <Navigate to={EXPERIENCE_ROUTES.Experiences_Content} replace />,
  },
  {
    path: EXPERIENCE_ROUTES.Experiences_CheckoutBlocks,
    element: <Navigate to={EXPERIENCE_ROUTES.Experiences_Checkout} replace />,
  },
  {
    path: EXPERIENCE_ROUTES.Experiences_CheckoutBlocks_Old,
    element: <Navigate to={EXPERIENCE_ROUTES.Experiences_Checkout} replace />,
  },
  {
    path: EXPERIENCE_ROUTES.Experiences_PostPurchase,
    element: (
      <Navigate to={EXPERIENCE_ROUTES.Experiences_PostPurchaseModule} replace />
    ),
  },
];
